import { render, staticRenderFns } from "./ModalStructureMa.vue?vue&type=template&id=b77d9562&"
import script from "./ModalStructureMa.vue?vue&type=script&lang=js&"
export * from "./ModalStructureMa.vue?vue&type=script&lang=js&"
import style0 from "./ModalStructureMa.vue?vue&type=style&index=0&id=b77d9562&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports